import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { OverlayPopup } from '../common/modals/OverlayPopup';
import NumberUtils from '../../utils/NumberUtils';
import SpendingsUtils from '../../utils/SpendingsUtils';

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work could help to make this conform to better
 * standards.
 */
class CreateBudgetTableRowTemplateMobile extends Component {
  constructor(props) {
    super(props);

    this._decrement = this._decrement.bind(this);
    this._increment = this._increment.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onPaste = this._onPaste.bind(this);

    this.state = {
      target_amount:
        props.rowData.target_amount <= 0 ? null : props.rowData.target_amount,
      isDisabledDecrease: props.rowData.target_amount <= 0,
      isDisabledIncrease: false,
    };
  }

  _decrement() {
    let el;
    if (!this.state.target_amount) {
      el = 0;
    } else {
      let targetAmount;
      if (_.isNumber(this.state.target_amount)) {
        targetAmount = this.state.target_amount;
      } else {
        targetAmount = Number(this.state.target_amount.replace(/[^\d.]*/g, ''));
      }
      el = targetAmount;
    }
    let value;
    const roundOffValue = el % 10;
    if (roundOffValue !== 0) {
      value = NumberUtils.appendCurrency('{}', Number(el - roundOffValue));
    } else {
      value = NumberUtils.appendCurrency('{}', Number(el - 10));
    }
    this.setState({ target_amount: value, isDisabledIncrease: false }, () => {
      let targetAmount;
      if (this.state.target_amount) {
        if (_.isNumber(this.state.target_amount)) {
          targetAmount = this.state.target_amount;
        } else {
          targetAmount = Number(
            this.state.target_amount.replace(/[^\d.]*/g, '')
          );
        }
      } else {
        targetAmount = 0;
      }
      const difference = targetAmount - this.props.rowData.target_amount;
      this.props.customClick(this.props.rowData.key, difference);
    });
    if (value.replace(/[^\d.]*/g, '') <= 0) {
      this.setState({ target_amount: null, isDisabledDecrease: true });
    }
  }

  _increment() {
    let el;

    if (!this.state.target_amount) {
      el = 0;
    } else {
      let targetAmount;
      if (_.isNumber(this.state.target_amount)) {
        targetAmount = this.state.target_amount;
      } else {
        targetAmount = Number(this.state.target_amount.replace(/[^\d.]*/g, ''));
      }
      el = targetAmount;
    }

    let value;
    const roundOffValue = el % 10;

    if (roundOffValue !== 0) {
      const diff = 10 - roundOffValue;
      value = NumberUtils.appendCurrency('{}', Number(el + diff));
    } else {
      if (el <= 9990) {
        value = NumberUtils.appendCurrency('{}', Number(el + 10));
      } else {
        value = NumberUtils.appendCurrency('{}', Number(el + 0));
      }
    }

    this.setState({ target_amount: value, isDisabledDecrease: false }, () => {
      let targetAmount;
      if (_.isNumber(this.state.target_amount)) {
        targetAmount = this.state.target_amount;
      } else {
        targetAmount = Number(this.state.target_amount.replace(/[^\d.]*/g, ''));
      }
      if (targetAmount === 9999.99999) {
        this.setState({ isDisabledIncrease: true });
      }
      const difference = targetAmount - this.props.rowData.target_amount;
      this.props.customClick(this.props.rowData.key, difference);
    });
  }

  _onBlur() {
    let targetAmount;
    let value;
    if (_.isNumber(this.state.target_amount)) {
      value = NumberUtils.appendCurrency(
        '{}',
        Number(this.state.target_amount)
      );
    } else {
      if (
        !(
          _.isNull(this.state.target_amount) ||
          _.isUndefined(this.state.target_amount)
        )
      ) {
        value = Number(this.state.target_amount.replace(/[^\d.]*/g, ''));
        value = NumberUtils.appendCurrency('{}', Number(value));
      }
    }
    this.setState({ target_amount: value });
    if (this.state.target_amount) {
      if (_.isNumber(this.state.target_amount)) {
        targetAmount = this.state.target_amount;
      } else {
        if (
          !(
            _.isNull(this.state.target_amount) ||
            _.isUndefined(this.state.target_amount)
          )
        ) {
          targetAmount = Number(
            this.state.target_amount.replace(/[^\d.]*/g, '')
          );
        }
      }
      let difference;
      if (
        !(
          _.isNull(this.state.target_amount) ||
          _.isUndefined(this.state.target_amount)
        )
      ) {
        difference = targetAmount - this.props.rowData.target_amount;
      }
      this.props.customClick(this.props.rowData.key, difference);
    }
    if (targetAmount === 0 || targetAmount < 0) {
      this.setState({ target_amount: null, isDisabledDecrease: true });
    }
    if (targetAmount <= 10000) {
      this.setState({ isDisabledIncrease: false });
    }
  }

  _onChange(e) {
    const isValid = SpendingsUtils.numberValidationForCreateEditBudget(
      e.target.value
    );
    if (isValid) {
      let value;
      const etarget = e.target.value.replace(/[^\d.]*/g, '');
      if (etarget === '' || etarget === 0) {
        value = '£';
      } else {
        value = `£${etarget}`;
      }
      this.setState({ target_amount: value });
      if (etarget > 0) {
        this.setState({ isDisabledDecrease: false });
      }
      if (etarget <= 10000) {
        this.setState({ isDisabledIncrease: false });
      }
    }
  }

  _onPaste(e) {
    e.preventDefault();
  }

  render() {
    const rowData = this.props.rowData;
    const lastMonth = rowData.last_month;
    const content = this.props.content;
    let targetAmount = this.state.target_amount;
    let pageData;
    const checkNan = Number(targetAmount);
    if (!_.isNaN(checkNan)) {
      if (targetAmount !== null) {
        targetAmount = NumberUtils.appendCurrency('{}', Number(targetAmount));
      }
    }

    let differencePot;
    let potColor = 'potcolor green';
    if (rowData.name === 'Pots') {
      differencePot =
        rowData.earnings.period.net_income.value - rowData.target_amount;
    }
    if (differencePot < 0) {
      potColor = 'potcolor red';
    }

    if (rowData.name === 'Pots') {
      const amount = NumberUtils.appendCurrency('{}', rowData.target_amount);
      pageData = (
        <article className="pots">
          <section>
            <span className={potColor} />
            <h6>{rowData.name}</h6>
          </section>
          <section>
            <h5>{amount}</h5>
          </section>
          <section>
            <OverlayPopup
              overlayId="pots_key"
              overlayMessage={content.spendingPotTooltipMessage}
              placement="bottom"
            >
              <span className="icon icon-information" />
            </OverlayPopup>
          </section>
        </article>
      );
    } else {
      pageData = (
        <article>
          <label>
            <span className="icon icon-tag" />
            {rowData.name}
          </label>

          <section>
            <h6>{content.spendingTableHeaderText7}</h6>
            <h5>{NumberUtils.appendCurrency('{}', Number(lastMonth))}</h5>
          </section>

          <section>
            <h6>{content.spendingTableHeaderText8}</h6>
            <input
              autoComplete="off"
              placeholder={content.spendingTableMessage10}
              type="text"
              value={targetAmount}
              className="form-control"
              id="potScheduleValue"
              onBlur={this._onBlur}
              onChange={this._onChange}
              onPaste={this._onPaste}
            />
          </section>
          <section className="add-btn">
            <div className="btn-numberAdjust">
              <button
                onClick={this._decrement}
                type="button"
                disabled={this.state.isDisabledDecrease}
              >
                <img src="../images/b/icons/remove.svg" alt="Remove" />
              </button>
              <button
                onClick={this._increment}
                type="button"
                disabled={this.state.isDisabledIncrease}
              >
                <img src="../images/b/icons/add.svg" alt="Add" />
              </button>
            </div>
          </section>
        </article>
      );
    }

    return <div className="transaction-mobile-row">{pageData}</div>;
  }
}

CreateBudgetTableRowTemplateMobile.propTypes = {
  rowData: PropTypes.object,
  metadata: PropTypes.object,
  customClick: PropTypes.func,
  content: PropTypes.object,
};

export { CreateBudgetTableRowTemplateMobile };
